import React, { useEffect, useState } from 'react'
import NoResults from './NoResultsFound'
import SearchNavAndTabs from './SearchNavAndTabs'
import { Fade } from 'ui/acro'
import { axios } from 'api'

const SearchResults = ({ query }) => {
  const [data, setData] = useState(null)
  useEffect(() => {
    axios
      .get(`/search/results?q=${query}`)
      .then((res) => {
        setData(res.data)
      })
      .catch((err) => console.log(err))
  }, [query])
  const resultsReturned = data && data.totalResultsReturned > 0

  if (data) {
    return (
      <Fade appear={true}>
        {resultsReturned ? (
          <SearchNavAndTabs data={data} />
        ) : (
          <NoResults query={query} />
        )}
      </Fade>
    )
  } else return <></>
}

export default SearchResults
